import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import BufferTabView from 'buffers/BufferTabView';
import {REQUESTS_V2_ANALYTICS_ACTIONS} from 'constants/analytics-products/RequestsV2AnalyticsConstants';
import {ActionMethod, ActionOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import RequestV2SubmissionDocument from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocument';
import RequestV2SubmissionDocumentTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class RequestV2SubmissionDocumentTabView extends BufferTabView<RequestV2SubmissionDocumentTabState> {
  override render(): this {
    const onSubmissionAddProgressAndOutputsTab = (): void => {
      const requestV2SubmissionFileState = this.model.getRequestV2SubmissionFileState();
      requestV2SubmissionFileState.addProgressAndOutputsTab();
    };
    const props = {
      requestV2SubmissionId: this.model.get('id'),
      onSubmissionAddProgressAndOutputsTab,
    };
    analytics.trackEvent(REQUESTS_V2_ANALYTICS_ACTIONS.CLICKED_REQUEST_V2_REQUEST_TAB, {
      request_v2_submission_id: props.requestV2SubmissionId,
      action_origin: ActionOrigin.REQUEST_V2_SUBMISSION,
      action_method: ActionMethod.BUTTON_CLICK,
    });
    renderToDOM(
      <div className="react-tab-container" style={{padding: 0}}>
        <RequestV2SubmissionDocument {...props} />
      </div>,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<RequestV2SubmissionDocumentTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestV2SubmissionDocumentTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
